import { KnobTogether } from 'react-together-primereact'

export function PrimeReactKnobTogetherDemo() {
  return (
    <div className='flex-col place-items-center'>
      <KnobTogether rtKey='knob-doc-demo' />
    </div>
  )
}
